module.exports = __webpack_public_path__ + "img/0x65e66a61D0a8F1e686C2D6083ad611a10D84D97A.7162c98b.png";